import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import dayjs from 'dayjs';
import { objectToURL } from '@/utils';

const useQueryGp = (targetDate?: dayjs.Dayjs) => {
  // UTC KST 시차
  const monthStart = dayjs.utc(targetDate ?? undefined).startOf('month');

  return useQuery({
    queryKey: ['gp-monthly-data', monthStart.format('YYYY-MM')],
    queryFn: async () => {
      const query = {
        epoch: monthStart.toISOString(),
      };

      const { data } = await axios.get<{ data: any[] }>(
        `${process.env.REACT_APP_API_URL}/gps/monthly${objectToURL(query)}`,
        { withCredentials: false }
      );
      return data;
    },
    staleTime: Infinity,
    gcTime: 30 * 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};

const useQueryGpMonthly = (targetDate?: dayjs.Dayjs) => {
  const monthStart = dayjs.utc(targetDate ?? undefined).startOf('month');
  return useQuery({
    queryKey: ['gp-monthly', monthStart.format('YYYY-MM')],
    queryFn: async () => {
      const { data } = await axios.get<{ data: any[] }>(
        `${process.env.REACT_APP_API_URL}/gps/monthly-count?epoch=${monthStart.format('YYYY-MM-DD')}T12:00:00Z`,
        { withCredentials: false }
      );
      return data;
    },
    staleTime: Infinity,
    gcTime: 30 * 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};

const useQueryGpMonthlyPayloads = (targetDate?: dayjs.Dayjs) => {
  const monthStart = dayjs.utc(targetDate ?? undefined).startOf('month');
  return useQuery({
    queryKey: ['gp-monthly-payloads', monthStart.format('YYYY-MM')],
    queryFn: async () => {
      const { data } = await axios.get<{ data: any[] }>(
        `${process.env.REACT_APP_API_URL}/gps/monthly-count?epoch=${monthStart.format('YYYY-MM-DD')}T12:00:00Z&objectType=PAYLOAD`,
        { withCredentials: false }
      );
      return data;
    },
    staleTime: Infinity,
    gcTime: 30 * 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};

const useQueryGpMonthlyDebris = (targetDate?: dayjs.Dayjs) => {
  const monthStart = dayjs.utc(targetDate ?? undefined).startOf('month');
  return useQuery({
    queryKey: ['gp-monthly-debris', monthStart.format('YYYY-MM')],
    queryFn: async () => {
      const { data } = await axios.get<{ data: any[] }>(
        `${process.env.REACT_APP_API_URL}/gps/monthly-count?epoch=${monthStart.format('YYYY-MM-DD')}T12:00:00Z&objectType=DEBRIS`,
        { withCredentials: false }
      );
      return data;
    },
    staleTime: Infinity,
    gcTime: 30 * 24 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};

export {
  useQueryGp,
  useQueryGpMonthlyPayloads,
  useQueryGpMonthlyDebris,
  useQueryGpMonthly,
};
